import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import MinusIcon from './MinusIcon'
import PlusIcon from './PlusIcon'

const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  cursor: pointer;

  /* Set the fill here because the shared icons do not define one; hover only the icon. */
  & svg {
    flex: none;
    width: 24px;
    height: 24px;
    fill: ${p => p.theme.lightestGray};
    transition: fill 0.3s;
  }

  &:hover svg {
    fill: ${p => p.theme.mediumGray};
  }

  &:focus-visible {
    outline: 2px solid ${p => p.theme.primaryColor};
    outline-offset: 4px;
    border-radius: 4px;
  }
`

const DisclosureToggle = ({ expanded, onToggle, children, className }) => (
  <Toggle type='button' className={className} aria-expanded={expanded} onClick={onToggle}>
    {expanded ? <MinusIcon aria-hidden='true' /> : <PlusIcon aria-hidden='true' />}
    {children}
  </Toggle>
)

DisclosureToggle.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default DisclosureToggle
